import React from "react";
import { useHistory } from "react-router-dom";
import { Auth0Provider, withAuthenticationRequired } from "@auth0/auth0-react";

// import { createBrowserHistory } from "history";

// export const history = createBrowserHistory();

const Auth0ProviderWithHistory = ({ children }) => {
  const history = useHistory();
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
      // Persist the session across reloads and renew via refresh token instead
      // of a hidden /authorize iframe: with the in-memory cache every page load
      // re-ran /authorize and, under MFA-on-every-sign-in, re-prompted for SMS
      // until the per-user limit locked the account. Requires "Allow Offline
      // Access" on the API in Auth0; until that is on, the SDK falls back to the
      // iframe (previous behaviour).
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
